var $b7a611726449f4a3$exports = {};
$b7a611726449f4a3$exports = {
    "Clear search": `\u{AC80}\u{C0C9} \u{C9C0}\u{C6B0}\u{AE30}`
};


export {$b7a611726449f4a3$exports as default};
//# sourceMappingURL=ko-KR.module.js.map
